import Button from '@doordash/component-button'
import { Modal } from '@doordash/component-modal'
import { Text } from '@doordash/design-language'
import * as React from 'react'
import { connect } from 'react-redux'
import * as events from '../../../events'
import * as DA from '../../../typeModules/events'
import t from './strings'

type Props = {
  onClose: any
  trackInsuranceTermsModal?: (data: DA.InsuranceTermsModal) => Promise<any>
}
export const InsuranceTermsModal: React.FC<Props> = ({
  trackInsuranceTermsModal,
  onClose,
}) => {
  React.useEffect(() => {
    trackInsuranceTermsModal({
      action: DA.InsuranceTermsModalActions.Rendered,
    })
  }, [trackInsuranceTermsModal])

  return (
    <Modal
      size={Modal.Sizes.Small}
      headerAlignment={Modal.HeaderAlignment.Center}
      hasCloseButton={false}
      isFullScreenOnMobile={false}
      actionsFillContainer={true}
      hasContentPadding={true}
      title={t.termsTitle()}
      primaryAction={{
        text: t.primaryActionModal(),
        onClick: () => {
          trackInsuranceTermsModal({
            action: DA.InsuranceTermsModalActions.Clicked,
            data: { clicked: 'primary' },
          })
          onClose()
        },
        buttonProps: { type: Button.Types.PrimaryPill },
      }}
    >
      <Text styles={Text.Styles.SectionSubtext}>{t.terms()}</Text>
    </Modal>
  )
}

const mapDispatchToProps = {
  trackInsuranceTermsModal: events.trackInsuranceTermsModal,
}
export default connect(null, mapDispatchToProps)(InsuranceTermsModal)
